import styled from 'styled-components';
import { mediaBreakpointMixin, Spacer } from '@zillow/constellation';

export const StyledCTAContainerSpacer = styled(Spacer)`
  /* 0 */
  @media ${mediaBreakpointMixin('xs')} {
    align-self: stretch;
  }

  /* 481 */
  @media ${mediaBreakpointMixin('md')} {
    align-self: unset;
  }
`;
